import React, {Component} from 'react';
import {Row, Col, Progress, Card, Alert, ListGroupItem, ListGroup, CardHeader, CardTitle, FormGroup, Label, Form, Input, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Button, ButtonDropdown, Table, Badge,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem, FormText, InputGroup} from 'reactstrap';
import { ajaxWrapperPost, ajaxWrapperGet, ajaxWrapperDelete } from '../../../utils/deviceAPI';
import { TextMask, InputAdapter } from 'react-text-mask-hoc';
import LoadingIndicator from '../../../utils/LoadingIndicator';
import UsersNotificationSystem from '../../Admin/Users/UsersNotificationSystem';





class Configuration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            addNewCustomPhoneNumber: false,
            addNewNotificationSms: "",
            addNewNotificationSmsVisibility: false,
            phoneValid: false,
            modalDeleteNotification: false,
            phoneNumberDelete: "",
            modalNote: false,
            note: "",
            notePhoneNumber: ""
        };
        this.handleChange = this.handleChange.bind(this);
        this.addNewNotificationSms = this.addNewNotificationSms.bind(this);
        this.defaults = this.defaults.bind(this);
        this.deleteNotification = this.deleteNotification.bind(this);
        this.noteModal = this.noteModal.bind(this);
        this.noteModalState = this.noteModalState.bind(this);
        this.removeNotificationConfirm = this.removeNotificationConfirm.bind(this);
        this.noteUpdateChanges = this.noteUpdateChanges.bind(this);
    }
    componentDidMount() {
        this.setData();
    }
    componentWillReceiveProps(nextProps) {
        const dev = this.props.match.params.dev.replace('device_','');
        const newDev = nextProps.match.params.dev.replace('device_','');
        if (dev !== newDev ) {
            this.setData(newDev);
        }
    }
    componentWillUnmount(){

    }
    setData(device = this.props.match.params.dev.replace('device_','')) {
        ajaxWrapperGet('/api/site/configuration/getSiteConfiguration',device).then((data) => {
            this.setState({
                data,
                loading: false
            });

        });
    }
    toggleSms(id,sms) {
        let postData = {
            dev: this.props.match.params.dev.replace('device_',''),
            user: id,
            sms:!sms
        };
        ajaxWrapperPost(`/api/site/configuration/addRemoveSms`,postData).then((data) => {
            if (data.error === false) {
                this.refs.notification.notify(data.message,'success');
                this.setData();
            }
            else if (data.error === true) {
                this.refs.notification.notify(data.message,'error');
            }
        });

    }

    toggleEmail(id,email) {
        let postData = {
            dev: this.props.match.params.dev.replace('device_',''),
            user: id,
            email:!email
        };
        ajaxWrapperPost(`/api/site/configuration/addRemoveEmail`,postData).then((data) => {
            if (data.error === false) {
                this.refs.notification.notify(data.message,'success');
                this.setData();
            }
            else if (data.error === true) {
                this.refs.notification.notify(data.message,'error');
            }
        });

    }
    deleteNotification() {
        this.setState({
            modalDeleteNotification: !this.state.modalDeleteNotification
        });
    }
    noteModal() {
        this.setState({
            modalNote: !this.state.modalNote
        });
    }
    removeNotificationState(phoneNumber) {
        this.setState({
            phoneNumberDelete: phoneNumber
        });
    }
    noteModalState(phoneNumber,note) {
        this.setState({
            note: note,
            notePhoneNumber: phoneNumber
        });
    }
    removeNotificationConfirm() {
        let postData = {
            dev: this.props.match.params.dev.replace('device_',''),
            phoneNumberDelete: this.state.phoneNumberDelete
        };
        ajaxWrapperPost(`/api/site/configuration/removeCustomSms`,postData).then((data) => {
            if (data.error === false) {
                this.refs.notification.notify(data.message,'success');
                this.setData();
                this.deleteNotification();
            }
            else if (data.error === true) {
                this.refs.notification.notify(data.message,'error');
            }
        });
    }
    noteUpdateChanges() {
        let postData = {
            dev: this.props.match.params.dev.replace('device_',''),
            notePhoneNumber: this.state.notePhoneNumber,
            note: this.state.note
        };
        ajaxWrapperPost(`/api/site/configuration/noteCustomSms`,postData).then((data) => {
            if (data.error === false) {
                this.refs.notification.notify(data.message,'success');
                this.setData();
                this.noteModal();
            }
            else if (data.error === true) {
                this.refs.notification.notify(data.message,'error');
            }
        });
    }
    handleChange({ target }) {
        const name = target.name;
        const value = target.value;
        let protocol = this.state.addNewNotificationProtocol;
        let sms = this.state.addNewNotificationSms;
        let smsVis = this.state.addNewNotificationSmsVisibility;
        let email = "";

        if (target.id === "addNewNotificationSms") {
            sms = value;
        }
        if (target.id === "addNewNotificationProtocol"){
            smsVis = value === "sms";
            protocol = value;
        }

        this.setState({
                addNewNotificationSms: sms,
                addNewNotificationProtocol:protocol,
                addNewNotificationSmsVisibility: smsVis
            },
            () => { this.validateField(target.id, value) }
        );

    }
    addNewNotificationSms() {
        let postData = {
            dev: this.props.match.params.dev.replace('device_',''),
            phoneNumber: this.state.addNewNotificationSms
        };

        ajaxWrapperPost(`/api/site/configuration/addCustomSms`,postData).then((data) => {
            if (data.error === false) {
                this.refs.notification.notify(data.message,'success');
                this.setData();
                this.defaults();
            }
            else if (data.error === true) {
                this.refs.notification.notify(data.message,'error');
            }

        });

    }

    defaults() {
        this.setState({
            addNewNotificationSms: "",
            phoneValid: false,
            addNewCustomPhoneNumber: false
        });
    }

    validateField(fieldName, value) {
        let telValid = /^\s*(?:\+?(\d{1,3}))?[- (]*(\d{3})[- )]*(\d{3})[- ]*(\d{4})(?: *[x/#]{1}(\d+))?\s*$/;
        let internalPhoneValid = this.state.phoneValid;
        let sms = this.state.addNewNotificationSms;


        switch(fieldName) {
            case 'addNewNotificationSms':
                internalPhoneValid = telValid.test(value);
                if (value.length >= 18) {
                    sms = sms.slice(0, -1);
                }
                break;
        }

        this.setState({
            phoneValid : internalPhoneValid,
            addNewNotificationSms: sms
        });
    }

    render() {
        if (this.state.loading) {
            return <LoadingIndicator />;
        }
        console.log(this.state.data);
        const { data } = this.state;
        return (

            <div className="containerAnimation">
                <div className="fadeInUp">
                <UsersNotificationSystem ref="notification"/>
                <Modal isOpen={this.state.modalDeleteNotification} toggle={this.deleteNotification}>
                    <ModalBody>
                        <Row>
                            <Col sm="10">
                                <CardTitle className="mb-1">Remove Notification</CardTitle>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="12">
                                <hr className="mb-4"/>
                            </Col>
                        </Row>
                        <Row className="pb-2">
                            <Col sm="12">
                                <div className="text-justify">Remove {this.state.phoneNumberDelete} from the notification list?</div>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="12">
                                <hr className="mb-4"/>
                            </Col>
                        </Row>
                        <Row className="pb-4">
                            <Col sm="6" className="small text-muted">
                                <Button color="link" className="btn btn-block" onClick={this.deleteNotification}>Cancel</Button>
                            </Col>
                            <Col sm="6" className="small text-muted">
                                <Button color="danger" className="btn btn-block" onClick={this.removeNotificationConfirm}>Remove</Button>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.modalNote} toggle={this.noteModal}>
                    <ModalBody>
                        <Row>
                            <Col sm="10">
                                <CardTitle className="mb-1">Edit Note for {this.state.notePhoneNumber}</CardTitle>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="12">
                                <hr className="mb-4"/>
                            </Col>
                        </Row>
                        <Row className="pb-2">
                            <Col sm="12">
                                <Input type="textarea" name="note" id="note" rows="9"
                                       placeholder="Notes...." onChange={({target}) => this.setState({note:target.value})} value={this.state.note}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="12">
                                <hr className="mb-4"/>
                            </Col>
                        </Row>
                        <Row className="pb-4">
                            <Col sm="6" className="small text-muted">
                                <Button color="link" className="btn btn-block" onClick={this.noteModal}>Cancel</Button>
                            </Col>
                            <Col sm="6" className="small text-muted">
                                <Button color="primary" className="btn btn-block" onClick={this.noteUpdateChanges}>Update</Button>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>
                <Row>
                    <Col sm="12" xl="12">
                        <Card>
                            <CardBody>
                                <Row className="pb-2">
                                    <Col sm="10">
                                        <CardTitle className="mb-1">Current UserNotification</CardTitle>
                                        <div className="small text-muted">modify user notification</div>
                                    </Col>
                                    <Col sm="2" className="d-none d-sm-inline-block">
                                        <i className="fa fa-phone float-right text-secondary"></i>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="12">
                                        <hr className="mb-4"/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="12">
                                        <Row className="mt-2 mb-2">
                                            <Col sm="6" md="4" lg="3" className="text-muted small"><strong>NAME</strong></Col>
                                            <Col sm="6" md="4" lg="6" className="text-muted small"><strong>COMPANY</strong></Col>
                                            <Col sm="1" md="2" lg="1" className="text-muted small d-sm-none d-md-block"><strong>SMS</strong></Col>
                                            <Col sm="1" md="2" lg="1" className="text-muted small d-sm-none d-md-block"><strong>EMAIL</strong></Col>
                                            <Col sm="12">
                                                <hr className="mb-2"/>
                                            </Col>
                                        </Row>
                                    {data.users.map((user,index) => {
                                        return (
                                            <Row key={index} className="mt-3 mb-3">
                                                <Col sm="6" md="4" lg="3">
                                                    {user.firstname} {user.lastname}
                                                </Col>
                                                <Col sm="6" md="4" lg="6" className="text-muted small text-uppercase ">
                                                    {user.company}
                                                </Col>
                                                <Col xs="6" sm="6" md="2" lg="1" className="pt-sm-3 pb-sm-3 pt-md-0 pb-md-0">
                                                    <div className="pretty p-default p-curve p-pulse">
                                                        <input type="checkbox" onClick={() => this.toggleSms(user.id, user.notifySms)} checked={user.notifySms}/>
                                                        <div className="state p-success text-muted small">
                                                            <label>SMS</label>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col xs="6" sm="6" md="2" lg="1" className="pt-sm-3 pb-sm-3 pt-md-0 pb-md-0">
                                                    <div className="pretty p-default p-curve p-pulse">
                                                        <input type="checkbox" onClick={() => this.toggleEmail(user.id, user.notifyEmail)} checked={user.notifyEmail}/>
                                                        <div className="state p-success text-muted small">
                                                            <label>Email</label>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col sm="12">
                                                    <hr className="mb-2" />
                                                </Col>
                                            </Row>
                                        )
                                    })}
                                    </Col>

                                </Row>

                                <Row className="pb-2 pt-5">
                                    <Col sm="10">
                                        <CardTitle className="mb-1">Custom Text Notifications</CardTitle>
                                        <div className="small text-muted">add or remove custom phone numbers to receive notifications.</div>
                                    </Col>
                                    <Col sm="2" className="d-none d-sm-inline-block">
                                        <i className="fa fa-phone float-right text-secondary"></i>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="12">
                                        <hr className="mb-4"/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="12">
                                        <Row className="mt-2 mb-2">
                                            <Col sm="4" md="4" className="text-muted small"><strong>PHONE NUMBER</strong></Col>
                                            <Col sm="6" md="7" className="text-muted small"><strong>NOTE</strong></Col>
                                            <Col sm="2" md="1" className="text-muted small"></Col>
                                            <Col sm="12">
                                                <hr className="mb-2"/>
                                            </Col>
                                        </Row>
                                        {data.other.map((data,index) => {
                                            return (
                                                <Row key={index} className="mt-2 mb-2">
                                                    <Col sm="4" md="4">{data.endpoint}</Col>
                                                    <Col sm="4" md="6" className="text-muted small">{data.note}</Col>
                                                    <Col sm="2" md="1" className="text-muted">
                                                        <Button color="light" className="btn-sm" block onClick={() => { this.noteModal(); this.noteModalState(data.endpoint,data.note);}}><i className="fa fa-pencil"></i></Button>
                                                    </Col>
                                                    <Col sm="2" md="1" className="text-muted">
                                                        <Button color="light" className="btn-sm" block onClick={() => { this.deleteNotification(); this.removeNotificationState(data.endpoint);}}><i className="fa fa-trash"></i></Button>
                                                    </Col>
                                                    <Col sm="12">
                                                        <hr className="mb-2"/>
                                                    </Col>
                                                </Row>
                                            )
                                        })}
                                        {(data.other.length === 0) ? (
                                            <Row className="mt-2 mb-2">
                                                <Col sm="12">There are currently no custom phone numbers added.</Col>
                                            </Row>
                                        ) : ""}
                                        {this.state.addNewCustomPhoneNumber && (
                                        <Row className="mt-2 mb-2">
                                            <Col sm="12">
                                                <InputGroup>
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><i className="fa fa-phone"></i></span>
                                                    </div>
                                                    <TextMask
                                                        mask={['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                                                        Component={InputAdapter}
                                                        className={this.state.phoneValid ? "form-control is-valid" : this.state.addNewNotificationSms === "" ? "form-control" : "form-control is-invalid"}
                                                        id="addNewNotificationSms"
                                                        onChange={ this.handleChange }
                                                        value = { this.state.addNewNotificationSms }
                                                    />
                                                    <div className="input-group-append">
                                                        <Button color="primary" className="btn-sm" block onClick={this.addNewNotificationSms} disabled={!this.state.phoneValid}>Add New Phone Number</Button>
                                                    </div>
                                                </InputGroup>
                                            </Col>
                                            <Col sm="12">
                                                <hr className="mb-2"/>
                                            </Col>
                                        </Row>
                                        )}
                                        {!this.state.addNewCustomPhoneNumber && (
                                            <Row className="mt-2 mb-2">
                                                <Col sm="4"></Col>
                                                <Col sm="4"><Button color="secondary" className="btn-sm" block onClick={() => this.setState({addNewCustomPhoneNumber:true})} ><i className="fa fa-plus"></i></Button></Col>
                                                <Col sm="4"></Col>
                                            </Row>
                                        )}
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
            </div>
        )
    }
}


export default Configuration;



// WEBPACK FOOTER //
// ./src/views/site/Configuration/Configuration.js